import React from 'react';
import { Button } from './Button';

const AlertIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
    <path d="M10 3L18 17H2L10 3Z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round"/>
    <path d="M10 9v4M10 14.5v.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

export function ErrorState({ title = 'Something went wrong', message, onRetry }) {
  return (
    <section className="ui-state" role="alert">
      <div className="ui-state-icon" style={{ color: 'var(--danger)' }}>
        <AlertIcon />
      </div>
      <h3>{title}</h3>
      {message && <p>{message}</p>}
      {onRetry ? (
        <Button variant="secondary" size="sm" onClick={onRetry}>
          Try again
        </Button>
      ) : null}
    </section>
  );
}
